export function createImportScriptsWorker(workerUrl: URL): Worker {
  if (isSafariBrowser()) {
    return createInlineWorker(workerUrl);
  }

  const blob = new Blob([`importScripts(${JSON.stringify(workerUrl.href)});`], {
    type: 'application/javascript',
  });
  return createWorkerFromBlob(blob);
}

export function createInlineWorker(workerUrl: URL): Worker {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', workerUrl.href, false);
  xhr.send();

  if (xhr.status < 200 || xhr.status >= 300 || !xhr.responseText) {
    throw new Error(`Failed to load worker script: ${workerUrl.href}`);
  }

  return createWorkerFromBlob(new Blob([xhr.responseText], { type: 'application/javascript' }));
}

function createWorkerFromBlob(blob: Blob): Worker {
  const blobUrl = URL.createObjectURL(blob);
  const worker = new Worker(blobUrl, { name: 'WssWorker' });
  const nativeTerminate = worker.terminate.bind(worker);
  let revoked = false;

  worker.terminate = () => {
    nativeTerminate();
    if (!revoked) {
      URL.revokeObjectURL(blobUrl);
      revoked = true;
    }
  };

  return worker;
}

function isSafariBrowser(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent;
  return /Safari/i.test(ua) && !/(Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android)/i.test(ua);
}
